import React from 'react';

import { MenuItem, Select, SelectProps } from '@mui/material';

import { Locale } from '../messages';
import { LOCALE_LABELS, SUPPORTED_LOCALES } from '../utils/locale';
import { useLocale } from '../utils/locale-provider';

type Props = Omit<SelectProps, 'value' | 'onChange'>;

export const LanguageSwitcher = (props: Props) => {
	const { locale, setLocale } = useLocale();

	return (
		<Select
			size="small"
			value={locale}
			onChange={(e) => setLocale(e.target.value as Locale)}
			{...props}
			sx={{ backgroundColor: 'background.paper', ...props.sx }}
		>
			{SUPPORTED_LOCALES.map((l) => (
				<MenuItem key={l} value={l}>
					{LOCALE_LABELS[l]}
				</MenuItem>
			))}
		</Select>
	);
};
